import React from 'react';
import { CheckCircle2, AlertCircle, XCircle, Clock } from 'lucide-react';
export type StatusType = 'passed' | 'failed' | 'warning' | 'pending';
interface StatusBadgeProps {
  status: StatusType;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}
export function StatusBadge({
  status,
  size = 'md',
  showLabel = true,
  className = ''
}: StatusBadgeProps) {
  const styles = {
    passed: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-700',
      border: 'border-emerald-200',
      icon: CheckCircle2,
      label: 'Passed'
    },
    failed: {
      bg: 'bg-red-50',
      text: 'text-red-700',
      border: 'border-red-200',
      icon: XCircle,
      label: 'Failed'
    },
    warning: {
      bg: 'bg-amber-50',
      text: 'text-amber-700',
      border: 'border-amber-200',
      icon: AlertCircle,
      label: 'Warning'
    },
    pending: {
      bg: 'bg-slate-100',
      text: 'text-slate-600',
      border: 'border-slate-200',
      icon: Clock,
      label: 'Pending'
    }
  };
  const config = styles[status];
  const Icon = config.icon;
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5 gap-1.5',
    md: 'text-sm px-3 py-1 gap-2',
    lg: 'text-base px-4 py-1.5 gap-2.5'
  };
  const iconSizes = {
    sm: 'w-3.5 h-3.5',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };
  return <div className={`
        inline-flex items-center font-medium rounded-full border
        ${config.bg} ${config.text} ${config.border}
        ${sizeClasses[size]}
        ${className}
      `} role="status" data-id="element-205">
      <Icon className={iconSizes[size]} aria-hidden="true" data-id="element-206" />
      {showLabel && <span data-id="element-207">{config.label}</span>}
    </div>;
}